export default __webpack_public_path__ + "static/media/013-volleyball.fe7ab1df.svg";